import React from 'react';
import PropTypes from 'prop-types';

import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import cx from 'classnames';

import inputTypes from '../FormInput/inputTypes';
import IfRender from '../../IfRender/index.jsx';

import './style.scss';

const XFormInput = React.forwardRef(
  (
    {
      id = '',
      disabled = false,
      type = inputTypes.text,
      name = '',
      label = '',
      checked = false,
      readOnly = false,
      placeholder = '',
      labelClass = '',
      inputClass = '',
      wrapClass = '',
      errorLabelClass = '',
      errorMessage = '',
      onChange,
      ...props
    },
    ref
  ) => {
    const { t } = useTranslation();
    const {
      formState: { errors }
    } = useFormContext();

    const handleChange = (e) => {
      if (onChange) {
        onChange(e);
      }
    };

    return (
      <div className={`input__wrap ${wrapClass}`}>
        <IfRender condition={label && type !== inputTypes.radio}>
          <label htmlFor={id} className={`input__label ${labelClass}`}>
            {label}
          </label>
        </IfRender>
        <input
          {...ref}
          {...props}
          id={id}
          name={name}
          disabled={disabled}
          type={type}
          readOnly={readOnly}
          placeholder={placeholder}
          checked={checked}
          onChange={handleChange}
          className={cx('input__field', disabled ? 'input__field__disabled' : null, inputClass, {
            checkbox: type === inputTypes.checkbox,
            radio: type === inputTypes.radio
          })}
        />
        <IfRender condition={label && type === inputTypes.radio}>
          <label htmlFor={id} className={`input__label ${labelClass}`}>
            {label}
          </label>
        </IfRender>
        <IfRender condition={errors?.[name]}>
          <label htmlFor={id} className={`input__label input__label--error ${errorLabelClass}`}>
            {t(errors?.[name]?.message)}
          </label>
        </IfRender>
      </div>
    );
  }
);

XFormInput.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  readOnly: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  labelClass: PropTypes.string,
  inputClass: PropTypes.string,
  wrapClass: PropTypes.string,
  errorLabelClass: PropTypes.string,
  errorMessage: PropTypes.string,
  onChange: PropTypes.func
};

export default XFormInput;
